function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * dom-dom v1.2.3
 * (c) 2017-present egoist <0x142857@gmail.com> (https://github.com/egoist)
 * Released under the MIT License.
 */
function setClassName(el, className) {
  if (typeof className === 'string') {
    el.className = className;
  } else if (Array.isArray(className)) {
    el.className = className.join(' ');
  } else if (_typeof(className) === 'object') {
    el.className = Object.keys(className).filter(function (name) {
      return className[name];
    }).join(' ');
  }
} // Copied from Preact


var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

function setStyle(el, style) {
  if (typeof style === 'string') {
    el.setAttribute('style', style);
  }

  if (_typeof(style) === 'object') {
    for (var key in style) {
      var value = style[key];

      if (typeof value === 'number' && !IS_NON_DIMENSIONAL.test(key)) {
        el.style[key] = value + "px";
      } else {
        el.style[key] = value;
      }
    }
  }
}

function recordLicecycleHooks(hooks, component) {
  for (var key in hooks) {
    if (component[key]) {
      hooks[key].push(component[key].bind(component));
    }
  }
}

function runHooks(hooks, name) {
  for (var i = 0, list = hooks[name]; i < list.length; i += 1) {
    var hook = list[i];
    hook();
  }
}

function addHooks(hooks, component, deep) {
  if (deep === void 0) deep = true;

  if (component.render) {
    recordLicecycleHooks(hooks, component);
    var node = component.render(component);

    if (deep && node && node.children) {
      for (var i = 0, list = node.children; i < list.length; i += 1) {
        var child = list[i];
        addHooks(hooks, child);
      }
    }
  }
}

var isSvgMode = false;

function createElement(ref, hooks) {
  var tag = ref.tag;
  var data = ref.data;
  var children = ref.children;
  if (hooks === void 0) hooks = {};
  var prevSvgMode = isSvgMode;
  isSvgMode = tag === 'svg' ? true : tag === 'foreignObject' ? false : isSvgMode;
  var el = isSvgMode ? document.createElementNS('http://www.w3.org/2000/svg', tag) : document.createElement(tag);

  if (data) {
    for (var key in data) {
      var value = data[key]; // Ignore `key`

      if (key === 'key') {
        continue;
      }

      if (key === 'class' || key === 'className') {
        setClassName(el, value);
      } else if (key === 'style') {
        setStyle(el, value);
      } else if (key === 'dangerouslySetInnerHTML') {
        if (value && value.__html) {
          el.innerHTML = value.__html;
        }
      } else if (key.substring(0, 2) === 'on') {
        el.addEventListener(key.substring(2).toLocaleLowerCase(), value);
      } else {
        el.setAttribute(key, value);
      }
    }
  }

  for (var i = 0, list = children; i < list.length; i += 1) {
    var child = list[i];

    if (child instanceof Element) {
      el.appendChild(child.cloneNode(true));
    } else if (_typeof(child) === 'object') {
      if (child.render) {
        // is a component
        el.appendChild(createElement(child.render()));
        recordLicecycleHooks(hooks, child);
      } else {
        el.appendChild(createElement(child));
      }
    } else {
      el.appendChild(document.createTextNode(child));
    }
  } // restore previous SVG mode: (in case we're exiting an SVG namespace)


  isSvgMode = prevSvgMode;
  return el;
}

var stack = [];
var EMPTY_CHILDREN = [];

function h(tag, data) {
  var arguments$1 = arguments;
  var children = EMPTY_CHILDREN;
  var lastSimple;
  var child;
  var simple;
  var i;

  for (i = arguments.length; i-- > 2;) {
    stack.push(arguments$1[i]);
  }

  while (stack.length) {
    if ((child = stack.pop()) && child.pop !== undefined) {
      for (i = child.length; i--;) {
        stack.push(child[i]);
      }
    } else {
      if (typeof child === 'boolean') {
        child = null;
      } // Currently all tag are simple


      if (simple = typeof tag === 'string') {
        if (child == null) {
          child = '';
        } else if (typeof child === 'number') {
          child = String(child);
        } else if (typeof child !== 'string') {
          simple = false;
        }
      }

      if (simple && lastSimple) {
        children[children.length - 1] += child;
      } else if (children === EMPTY_CHILDREN) {
        children = [child];
      } else {
        children.push(child);
      }

      lastSimple = simple;
    }
  }

  return {
    tag: tag,
    data: data,
    children: children
  };
}

function mount(node, root) {
  var hooks = {
    componentWillMount: [],
    componentDidMount: []
  };
  var el;

  if (node.render) {
    // Add hooks for root component only
    // Hooks in child components will be added in `createElement`
    addHooks(hooks, node, false);
    el = createElement(node.render(), hooks);
  } else {
    el = createElement(node, hooks);
  }

  if (root) {
    runHooks(hooks, 'componentWillMount');
    root.parentNode.replaceChild(el, root);
    runHooks(hooks, 'componentDidMount');
  }

  return el;
}

function unmount(node, root) {
  var hooks = {
    componentWillUnmount: []
  };
  addHooks(hooks, node);
  runHooks(hooks, 'componentWillUnmount');
  root && root.parentNode.removeChild(root);
}

export { createElement, h, mount, unmount };